import { NavigationLink } from "../../models/navigation-link";
import * as FetchUtil from "../fetch-util";

export interface NagivationLinksResponse {
  navigationLinks: NavigationLink[];
}

export class NavigationLinksService {
  static get(): Promise<FetchUtil.HttpResponse<NagivationLinksResponse>> {
    return FetchUtil.get(`/api/v1/ux/navigation`);
  }
}
